/* eslint-disable */

window.dataLayer = window.dataLayer || [];

function gtag() {

    dataLayer.push(arguments);

}

function loadGoogleAnalytics(trackId) {

    const ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = `https://www.googletagmanager.com/gtag/js?id=${trackId}`;

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);

    gtag('set', 'linker', {
        'domains': [
            'payment.nilo.app',
            '34.216.222.146',
            window.location.host,
        ]
    });
    gtag('js', new Date());
    gtag('config', trackId);

    gtag('get', trackId, 'client_id', (client_id) => {

        localStorage.setItem("ga_client_id", client_id);

    });

    gtag('get', trackId, 'session_id', (session_id) => {

        localStorage.setItem("ga_session_id", session_id);

    });
}

export default loadGoogleAnalytics;
